import { ReactNode } from 'react';
import { EntityRatingCommentCount, Laboratory, Rating } from '@medprev-web-app/api-graphql-client';

import { EntityRating } from '@/app/(main)/(pages)/_components/entities/entity-rating-sumary.component';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { resolveLaboratoryName } from '@/utils/laboratory/laboratory.util';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface BranchLaboratoryHeaderProps {
  laboratory: Laboratory;
  commentsCount?: EntityRatingCommentCount | null;
  coverageBanner?: ReactNode;
  actions?: ReactNode;
}

export function BranchLaboratoryHeader({
  laboratory,
  commentsCount,
  coverageBanner,
  actions,
}: BranchLaboratoryHeaderProps) {
  const formatAddress = (): string | undefined => {
    const { neighborhood, city, state } = laboratory;

    return `${neighborhood} • ${city} - ${state}`;
  };

  const laboratoryName = resolveLaboratoryName(laboratory);

  return (
    <>
      <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
        <div className="shrink-0">
          <EntityAvatar
            src={laboratory.main.avatar}
            size="xxxl"
            alt={`Foto de perfil de ${laboratoryName}`}
            type={EntityTypeEnum.LABORATORY_COLLECT_POINT}
            shouldAddLightbox
            priority
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_AVATAR}
          />
        </div>

        <div>
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            className="text-center md:text-left break-words text-wrap hyphens-auto overflow-hidden"
          >
            {laboratoryName}
          </Typography>

          <span className="mt-2 block text-center text-sm leading-5 text-gray-700 md:text-left">
            {formatAddress()}
          </span>
        </div>
      </div>
      <div className="mt-6">
        <EntityRating
          rating={laboratory.rating as Rating}
          commentsCount={commentsCount}
          data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_REVIEWS_AND_COMMENTS}
        />
      </div>

      {coverageBanner && <div className="mt-4">{coverageBanner}</div>}

      <div className={coverageBanner ? 'pt-3 pb-4' : 'py-4'}>
        {actions}
      </div>
    </>
  );
}
